<template>
  <span>
    <span v-if="notes">
      <v-dialog v-model="dialog" max-width="400" scrollable>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small icon v-bind="attrs" v-on="on">
            <v-icon small color="#d2a158">mdi-note-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title
            class="text-h5 grey lighten-2"
            style="word-break: break-word"
          >
            {{ title }}
          </v-card-title>

          <v-card-text class="mt-2">
            <notes-formatter
              :notes="notes"
              :sevenChar="sevenChar"
              class="my-3"
            ></notes-formatter>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </span>
  </span>
</template>

<script>
import NotesFormatter from "./NotesFormatter.vue";
// import Name from "../dir/file";

export default {
  components: {
    NotesFormatter,
  },
  name: "InclusionExclusionDialog",
  props: {
    notes: null,
    title: null,
    sevenChar: null,
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {},
  computed: {
    theTitle: function () {
      return this.title ? this.title : "Notes";
    },
  },
};
</script>

<style scoped></style>
